
import Vue from "vue";

export default Vue.extend({
  name: "component-vacancy-error-banner",
  components: {},
  props: {
    title: String,
    subtitle: String,
    btnTitle: String,
    status: String,
  },
  methods: {
    detailClicked() {
      this.$emit("detail-clicked", this.status);
    },
  },
});
